'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.occurrence = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _metricsReporterProvider = require('./metricsReporterProvider');

var _metricsReporterProvider2 = _interopRequireDefault(_metricsReporterProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var occurrence = exports.occurrence = function occurrence(name, occurrencePredicate) {
    var occurrencePolicy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'once';
    return (0, _recompose.lifecycle)({
        checkAndSend: function checkAndSend(predicate) {
            if (occurrencePolicy === 'once') {
                if (this.isSent) return;
            } else {
                // distinct function
                var currentValue = occurrencePolicy(this.props);
                if (this.lastDistinctValue !== undefined && this.lastDistinctValue === currentValue) return;
                this.lastDistinctValue = currentValue;
            }

            if (predicate()) {
                this.isSent = true;
                _metricsReporterProvider2.default.sendOccurrence(name);
            }
        },
        componentDidMount: function componentDidMount() {
            var _this = this;

            var check = function check() {
                return occurrencePredicate && occurrencePredicate(_this.props);
            };
            this.checkAndSend(check);
        },
        componentDidUpdate: function componentDidUpdate(prevProps) {
            var _this2 = this;

            var check = function check() {
                return occurrencePredicate && occurrencePredicate(_this2.props);
            };
            this.checkAndSend(check);
        }
    });
};